export const VIEW_GPS = 1;
export const VIEW_PATH = 2;
export const DEFAULT_COORDS = { latitude: '-33.441809', longitude: '-70.649966' };
export const SET_MAP_BOUNDS = 'SET_MAP_BOUNDS';

// export const DEFAULT_BOUNDS = { latitude: '-33.441809', longitude: '-70.649966' };
